import { Organization } from "@models/organization.model.ts";

export function getDescendantIds(orgId: number, all: Organization[]): Set<number> {
  const childrenByParent = new Map<number, number[]>();
  for (const o of all) {
    if (o.parent_id != null) {
      const arr = childrenByParent.get(o.parent_id) ?? [];
      arr.push(o.id);
      childrenByParent.set(o.parent_id, arr);
    }
  }
  const descendants = new Set<number>();
  const walk = (id: number) => {
    for (const childId of childrenByParent.get(id) ?? []) {
      if (descendants.has(childId)) continue;
      descendants.add(childId);
      walk(childId);
    }
  };
  walk(orgId);
  return descendants;
}
